import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";


const initMulticolumnCarousel = () => ({
   init: () => {
    const isWhyPvolve = document.querySelector(".page-why-pvolve");

    new Swiper(".multicolumn-carousel", {
        slidesPerView: 1.3,
        spaceBetween: 1,
        modules: [Navigation, Pagination],
        pagination: {
            el: ".multicolumn-carousel .swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".multicolumn-carousel .swiper-button-next",
            prevEl: ".multicolumn-carousel .swiper-button-prev",
        },

        breakpoints: {
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: isWhyPvolve ? 3 : 4,
            }
        }
    });

     new Swiper(".multicolumn-carousel-video", {
        slidesPerView: 1.3,
        modules: [Navigation, Pagination],
        pagination: {
            el: ".multicolumn-carousel-video .swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".multicolumn-carousel-video .swiper-button-next",
            prevEl: ".multicolumn-carousel-video .swiper-button-prev",
        },

        breakpoints: {
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 4,
            }
        }
    });
   }
})

document.addEventListener('DOMContentLoaded', () => {
    initMulticolumnCarousel().init();
})